import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as campaignActions from "../../../../redux/Campaign/actions";

const CampaignIndustry = props => {
	const {items, value, onChange} = props;

	if(!items) {
		return <div/>
	}

	return (
		<select className="edit-field-styles select-primary" onChange={(e) => onChange(e.target.selectedOptions[0].value)} value={value || ''}>
			<option key="-1" value="-1">Select Industry</option>
			{ items.map((t, i) => (<option value={t.value} key={i}>{t.label}</option>)) }
		</select>
	)
};

export default CampaignIndustry;
